import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import PowerBIDashboardViewer from '../../components/PowerBIDashboardViewer/PowerBIDashboardViewer';


const HomePage = () => {
  // USE HOOKS
  const renderContent = () => {
    return <PowerBIDashboardViewer />
  };

  // RENDER
  return (
    <Layout >
      {/* <Header style={{ backgroundColor: '#141417' }}>
        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
          <Col>
            <Button
              icon={<MenuOutlined />}
              type="primary"
              onClick={showDrawer}
              style={{ marginRight: '16px' }}
            />
          </Col>         
        </Row>
      </Header> */}
      <Content style={{ padding: '0 50px' }}>
        {renderContent()}
      </Content>
    </Layout>
  );
};

export default HomePage;
